import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSecurityDepositDetails } from "../../redux/customerSlice";
import {
  Box,
  Card,
  Flex,
  Heading,
  SimpleGrid,
  Text,
  VStack,
  useDisclosure,
  Badge,
  Image,
  HStack,
  Divider,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import CustomButton from "../../components/ButtonComp";
import { BiArrowBack } from "react-icons/bi";
import DisplayData from "../../components/DisplayData";
import Loader from "../../components/Loader";
import ImageModal from "../../components/ImageModal";
import { FiCalendar, FiCreditCard, FiDollarSign, FiUser, FiFileText } from "react-icons/fi";

const SecurityDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { customerDetails, detailsLoading } = useSelector((state) => state.customers);
  const { onOpen, onClose, isOpen } = useDisclosure();
  const [url, setUrl] = useState("");

  // Get data from navigation state
  const { customerId, orderid, type, page, rows, initialValue } = location.state || {};

  useEffect(() => {
    if (customerId) {
      dispatch(fetchSecurityDepositDetails({ 
        userid: customerId, 
        id: customerId 
      }));
    }
  }, [dispatch, customerId]);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
      case "paid":
      case "success":
        return "green";
      case "pending":
      case "processing":
        return "yellow";
      case "failed":
      case "cancelled":
        return "red";
      default:
        return "gray";
    }
  };

  // Get payment method color
  const getPaymentMethodColor = (method) => {
    switch (method?.toLowerCase()) {
      case "online":
      case "upi":
        return "blue";
      case "cash":
        return "green";
      case "card":
        return "purple";
      default:
        return "gray";
    }
  };

  // Extract data from the response
  const data = customerDetails?.data?.[0] || {};

  return (
    <>
      <Card
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justify={"space-between"}
        paddingInline={5}
        paddingBlock={2}
      >
        <Heading fontSize={"xl"}>Customer Details</Heading>
        <CustomButton
          icon={<BiArrowBack color="#fff" />}
          title={"Back"}
          height={"30px"}
          b_color={"#000"}
          onClick={() => {
            navigate("/customer-list", {
              state: {
                page: page || 1,
                rows: rows || 5,
                initialValue: initialValue || 1,
              },
            });            
          }}
        />
      </Card>

      {detailsLoading ? (
        <Card p={5} justify={"center"} alignItems={"center"}>
          <Loader />
        </Card>
      ) : (
        <VStack spacing={4} align="stretch">
          {/* Order Summary Card */}
          {/* <Card paddingInline={5} paddingBlock={4}>
            <Heading fontSize={"lg"} mb={4} color="blue.600">
              <Flex align="center" gap={2}>
                <FiFileText />
                Order Summary
              </Flex>
            </Heading>    
            <SimpleGrid columns={[1, 2, 4]} spacing={4}>
              <Box>
                <DisplayData
                  title={"Order ID"}
                  value={data?.orderid || orderid || "N/A"}
                  v_color={"#f37022"}
                  fw={"bold"}
                  fs={"18px"}
                />
              </Box>
              <Box>
                <DisplayData
                  title={"Customer ID"}
                  value={data?.userid || customerId || "N/A"}
                  v_color={"#007bc9"}
                  fw={"bold"}
                />
              </Box>
              <Box>
                <DisplayData
                  title={"Type"}
                  value={type || data?.type || "N/A"}
                />
              </Box>
              <Box>
                <Flex align="center" gap={2}>
                  <Text fontSize="sm" fontWeight="medium" color="gray.600">
                    Status:
                  </Text>
                  <Badge colorScheme={getStatusColor(data?.status)}>
                    {data?.status || "N/A"}
                  </Badge>
                </Flex>
              </Box>
            </SimpleGrid>
          </Card> */}

          {/* Customer Information Card */}
        {/* Customer Information Card */}
<Card p={6} borderRadius="lg" boxShadow="md" bg="white">
  <Heading fontSize="xl" mb={6} color="green.600">
    <Flex align="center" gap={2}>
      <FiUser />
      Customer Information
    </Flex>
  </Heading>

  <VStack spacing={8} align="stretch">

    {/* 🔵 Basic Details */}
    <Box>
      <Text fontWeight="bold" fontSize="md" mb={3} color="gray.700">
        Basic Details
      </Text>
      <SimpleGrid columns={[1, 2, 3]} spacing={5}>
        <DisplayData title="Customer Name" value={data?.name || "N/A"} />
        <DisplayData title="Mobile Number" value={data?.mobile || "N/A"} />
        <DisplayData title="Email" value={data?.email || "N/A"} />
        <DisplayData title="Secondary Email" value={data?.email2 || "N/A"} />
        <DisplayData title="Customer Type" value={data?.type || "N/A"} />
        <DisplayData title="Status" value={data?.status == "1" ? "Active" : "Inactive"} />
      </SimpleGrid>
    </Box>

    <Divider />

    {/* 🟢 Business Details */}
    <Box>
      <Text fontWeight="bold" fontSize="md" mb={3} color="gray.700">
        Business Details
      </Text>
      <SimpleGrid columns={[1, 2, 3]} spacing={5}>
        <DisplayData title="Business Name" value={data?.business_name || "N/A"} />
        <DisplayData title="Trade Name" value={data?.tradename || "N/A"} />
        <DisplayData title="Legal Name" value={data?.legalname || "N/A"} />
        <DisplayData title="GST Registered" value={data?.is_gst_reg || "N/A"} />
        <DisplayData title="GST Number" value={data?.gst || "N/A"} />
        <DisplayData title="PAN Number" value={data?.pan || "N/A"} />
      </SimpleGrid>
    </Box>

    <Divider />

    {/* 🟣 Address */}
    <Box>
      <Text fontWeight="bold" fontSize="md" mb={3} color="gray.700">
        Address Information
      </Text>
      <SimpleGrid columns={[1, 2, 3]} spacing={5}>
        <DisplayData title="Address" value={data?.address || "N/A"} />
        <DisplayData title="Pincode" value={data?.pincode || "N/A"} />
        <DisplayData title="Pincode Area" value={data?.pincode_area || "N/A"} />
        <DisplayData title="District" value={data?.district || "N/A"} />
        <DisplayData title="State" value={data?.state || "N/A"} />
      </SimpleGrid>
    </Box>

    <Divider />
  </VStack>
</Card>


          {/* Bank Details Card */}
          <Card paddingInline={5} paddingBlock={4}>
            <Heading fontSize={"lg"} mb={4} color="teal.600">
              Bank Details
            </Heading>
            {data?.bank && data.bank.length > 0 ? (
              <SimpleGrid columns={[1, 2]} spacing={4}>
                {data.bank.map((bank, index) => (
                  <Card key={index} p={4} boxShadow="md" borderRadius="md" bg="gray.50">
                    <VStack align="stretch" spacing={3}>
                      {/* Account Header */}
                      <Flex justify="space-between" align="center">
                        <Text fontWeight="bold" fontSize="md">Account #{index + 1}</Text>
                        {bank.status === "1" && (
                          <Badge colorScheme="green">Primary</Badge>
                        )}
                      </Flex>

                      {/* Bank Details */}
                      <Box>
                        <DisplayData title="Account Holder" value={bank.name || "N/A"} />
                        <DisplayData title="Bank Name" value={bank.bankname || "N/A"} />
                        <DisplayData title="Account Number" value={bank.accountno || "N/A"} />
                        <DisplayData title="Account Type" value={bank.ac_type || "N/A"} />
                        <DisplayData title="Branch" value={bank.bank_branch || "N/A"} />
                        <DisplayData title="IFSC Code" value={bank.ifsc || "N/A"} />
                        {bank.upi_id && (
                          <DisplayData title="UPI ID" value={bank.upi_id} />
                        )}
                        <DisplayData title="Added On" value={formatDate(bank.createdat)} />
                      </Box>

                      {/* QR Code Section with View Button */}
                      {bank.qr_code && (
                        <Box mt={3}>
                          <Flex align="center" justify="space-between" mb={2}>
                            <Text fontSize="sm" fontWeight="medium">
                              QR Code
                            </Text>
                            <CustomButton
                              title="View"
                              size="sm"
                              height="30px"
                              onClick={() => {
                                setUrl(bank.qr_code);
                                onOpen();
                              }}
                            />
                          </Flex>
                          <Box 
                            border="1px dashed" 
                            borderColor="gray.300" 
                            p={2} 
                            borderRadius="md"
                            textAlign="center"
                          >
                            <Image 
                              src={bank.qr_code} 
                              alt="Bank QR Code" 
                              maxW="120px" 
                              maxH="120px"
                            />
                          </Box>
                        </Box>
                      )}
                    </VStack>
                  </Card>
                ))}
              </SimpleGrid>
            ) : (
              <Box 
                p={4} 
                bg="gray.50" 
                borderRadius="md" 
                textAlign="center"
                color="gray.500"
              >
                <Text>No bank accounts available</Text>
              </Box>
            )}
          </Card>

          {/* Payment Information Card */}
          {/* <Card paddingInline={5} paddingBlock={4}>
            <Heading fontSize={"lg"} mb={4} color="purple.600">
              <Flex align="center" gap={2}>
                <FiDollarSign />
                Payment Information
              </Flex>
            </Heading>
            <SimpleGrid columns={[1, 2, 3]} spacing={4}>
              <Box>
                <DisplayData
                  title={"Amount"}
                  value={data?.amount ? `₹${data.amount}` : "N/A"}
                  v_color={"#2e7d32"}
                  fw={"bold"}
                  fs={"20px"}
                />
              </Box>
              <Box>
                <Flex align="center" gap={2}>
                  <Text fontSize="sm" fontWeight="medium" color="gray.600">
                    Payment Method:
                  </Text>
                  <Badge colorScheme={getPaymentMethodColor(data?.payment_method)}>
                    {data?.payment_method || "N/A"}
                  </Badge>
                </Flex>
              </Box>
              <DisplayData
                title={"Transaction ID"}
                value={data?.transaction_id || data?.txn_id || "N/A"}
              />
              <DisplayData
                title={"Payment Gateway"}
                value={data?.gateway || "N/A"}
              />
              <DisplayData
                title={"Reference Number"}
                value={data?.reference_no || "N/A"}
              />
              <DisplayData
                title={"UTR Number"}
                value={data?.utr_no || "N/A"}
              />
            </SimpleGrid>
          </Card> */}

          {/* Timeline Information Card */}
          <Card paddingInline={5} paddingBlock={4}>
            <Heading fontSize={"lg"} mb={4} color="teal.600">
              <Flex align="center" gap={2}>
                <FiCalendar />
                Timeline Information
              </Flex>
            </Heading>
            <SimpleGrid columns={[1, 2, 3]} spacing={4}>
              <DisplayData
                title={"Order Date"}
                value={formatDate(data?.datetime || data?.created_at)}
              />
              <DisplayData
                title={"Payment Date"}
                value={formatDate(data?.payment_date)}
              />
              <DisplayData
                title={"Updated At"}
                value={formatDate(data?.updated_at)}
              />
            </SimpleGrid>
          </Card>

          {/* Payment Receipt/Proof Section */}
          {data?.payment_proof && (
            <Card paddingInline={5} paddingBlock={4}>
              <Heading fontSize={"lg"} mb={4} color="orange.600">
                <Flex align="center" gap={2}>
                  <FiCreditCard />
                  Payment Proof
                </Flex>
              </Heading>
              <HStack spacing={4}>
                <CustomButton
                  title={"View Payment Proof"}
                  height={"40px"}
                  onClick={() => {
                    setUrl(data.payment_proof);
                    onOpen();
                  }}
                />
                {data.payment_proof && (
                  <Image 
                    src={data.payment_proof} 
                    alt="Payment Proof" 
                    maxW="150px" 
                    maxH="150px"
                    border="1px"
                    borderColor="gray.200"
                    borderRadius="md"
                  />
                )}
              </HStack>
            </Card>
          )}

          {/* Additional Details Card */}
          {(data?.remarks || data?.notes || data?.description) && (
            <Card paddingInline={5} paddingBlock={4}>
              <Heading fontSize={"lg"} mb={4} color="gray.600">
                Additional Details
              </Heading>
              <VStack align="stretch" spacing={3}>
                {data?.remarks && (
                  <DisplayData
                    title={"Remarks"}
                    value={data.remarks}
                  />
                )}
                {data?.notes && (
                  <DisplayData
                    title={"Notes"}
                    value={data.notes}
                  />
                )}
                {data?.description && (
                  <DisplayData
                    title={"Description"}
                    value={data.description}
                  />
                )}
              </VStack>
            </Card>
          )}

          {/* Order History Table (if available) */}
          {data?.history && data.history.length > 0 && (
            <Card paddingInline={5} paddingBlock={4}>
              <Heading fontSize={"lg"} mb={4} color="indigo.600">
                Order History
              </Heading>
              <TableContainer>
                <Table variant="simple" size="sm">
                  <Thead>
                    <Tr>
                      <Th>Date</Th>
                      <Th>Status</Th>
                      <Th>Action</Th>
                      <Th>Remarks</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data.history.map((item, index) => (
                      <Tr key={index}>
                        <Td>{formatDate(item.date)}</Td>
                        <Td>
                          <Badge colorScheme={getStatusColor(item.status)}>
                            {item.status}
                          </Badge>
                        </Td>
                        <Td>{item.action || "N/A"}</Td>
                        <Td>{item.remarks || "N/A"}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Card>
          )}

          {/* No Data Message */}
          {!data || Object.keys(data).length === 0 && (
            <Card paddingInline={5} paddingBlock={4}>
              <Box 
                p={8} 
                bg="gray.50" 
                borderRadius="md" 
                textAlign="center"
                color="gray.500"
              >
                <Text fontSize="lg">No details available for this security deposit</Text>
                <Text fontSize="sm" mt={2}>
                  Order ID: {orderid} | Customer ID: {customerId}
                </Text>
              </Box>
            </Card>
          )}
        </VStack>
      )}

      <ImageModal url={url} onClose={onClose} isOpen={isOpen} />
    </>
  );
};

export default SecurityDetail;